import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import { brightenKeyword } from "@/hooks/lightKeyword";
export default defineComponent({
  name: "SArtist",
  props: {
    artistList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    inputValue: {
      type: String,
      default: ""
    }
  },
  setup: function setup() {
    var router = useRouter();
    /* 关键字高亮 */

    var lightKeyword = brightenKeyword;
    /* 歌手点击事件 */

    var songerClick = function songerClick(id) {
      router.push("/main/artistdetail/".concat(id));
    };

    return {
      lightKeyword: lightKeyword,
      songerClick: songerClick
    };
  },
  components: {}
});